import { Col, Container, Row } from "react-bootstrap";
import {
  Basket,
  CartPlus,
  Collection,
  FileEarmarkDiff,
  PersonVcard,
} from "react-bootstrap-icons";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const shortcuts = [
    {
      title: "Contacts",
      link: "/dashboard/contacts",
      Icon: PersonVcard,
      bg: "primary",
    },
    {
      title: "Orders",
      link: "/dashboard/sales/orders",
      Icon: Basket,
      bg: "success",
    },
    {
      title: "New Order",
      link: "/dashboard/sales/orders/form",
      Icon: CartPlus,
      bg: "warning",
    },
    {
      title: "Drafts",
      link: "/dashboard/sales/orders/draft",
      Icon: FileEarmarkDiff,
      bg: "info",
    },
    {
      title: "Outbox",
      link: "/dashboard/sales/orders/outbox",
      Icon: Collection,
      bg: "dark",
    },
  ];

  return (
    <Container fluid>
      <Row className="my-3">
        {shortcuts.map((shortcut) => (
          <Col xs={6} md={3} lg={2} className="text-center">
            <Link to={shortcut.link} className="text-decoration-none m-5">
              <Container
                fluid
                className={`bg-${shortcut.bg} bg-opacity-25 bg-hoverable p-3 rounded`}
              >
                <shortcut.Icon size={40} color="dark" />
                <p className={`text-dark`}>{shortcut.title}</p>
              </Container>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Dashboard;
